import { SxProps, Theme, Tooltip } from '@mui/material';
import useDevice from 'hooks/DesktopDevice.hook';
import mobile from 'is-mobile';
import { cloneElement, isValidElement, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
	Box,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Typography,
} from 'styles';
import { colors } from 'styles/theme/Palette';
import { IAction } from 'utils/links';

type ListButtonProps = {
	onClick: () => void;
	action: IAction;
	open: boolean;
	sx?: SxProps<Theme>;
};

const ListItemButtonCustom = (props: ListButtonProps) => {
	const { open, onClick, action, sx = {} } = props;
	const location = useLocation();
	const [openTooltip, setOpenTooltip] = useState(false);
	const { isDesktop } = useDevice();
	const isMobile = mobile({ tablet: true, featureDetect: true });

	const isActive =
		action.link === '/'
			? location.pathname === action.link
			: location.pathname.startsWith(action.link);

	const iconColor = isActive ? colors.primary1 : colors.grey3;

	const iconNode = isActive
		? action.icon
		: action.unselected_route || action.icon;

	const coloredIcon = isValidElement(iconNode)
		? cloneElement(iconNode as React.ReactElement<any>, { color: iconColor })
		: iconNode;

	const handlerClick = () => {
		if (openTooltip) {
			setOpenTooltip(false);
		}
		onClick();
	};

	const handleClose = () => {
		setOpenTooltip(false);
	};

	const handleOpen = () => {
		setOpenTooltip(true);
	};

	const isTextColorActive =
		action.link === '/'
			? location.pathname === action.link
			: location.pathname.startsWith(action.link);

	return (
		<ListItem disablePadding sx={{ display: 'block' }}>
			<ListItemButton
				onMouseEnter={handleOpen}
				onMouseLeave={handleClose}
				sx={{
					minHeight: 0,
					justifyContent: open ? 'initial' : 'center',
					p: 0,
					mr: open ? 1.5 : 'auto',
					...sx,
				}}
				onClick={handlerClick}
			>
				<Tooltip
					open={!open && !isMobile ? openTooltip : false}
					disableTouchListener
					title={action.name}
					placement="right"
				>
					<Box display="flex" sx={{ width: '56px' }}>
						<ListItemIcon
							sx={{
								minWidth: '32px',
								height: '32px',
								mr: open ? 3 : 'auto',
								justifyContent: 'center',
								px: !isDesktop ? 0.5 : 0,
								alignItems: 'center',
							}}
						>
							{coloredIcon}
						</ListItemIcon>
					</Box>
				</Tooltip>
				<ListItemText sx={{ opacity: open ? 1 : 0, ml: !!isDesktop ? -1 : -1.875 }}>
					<Typography
						variant="bodyLink"
						sx={{
							color:
								isTextColorActive || action.id === 'dashboard_buttons_logout'
									? 'primary.main'
									: 'grey3.main',
						}}
					>
						{action.name}
					</Typography>
				</ListItemText>
			</ListItemButton>
		</ListItem>
	);
};

export default ListItemButtonCustom;
